import { useCallback, useState } from 'react';

import { useAutomationService } from '@/src/infrastructure/Protocol/Automation/useAutomationService';

export const useCreateJourney = () => {
  const automationService = useAutomationService();
  const [isLoading, setIsLoading] = useState(false);

  const createJourney = useCallback(
    async (name: string) => {
      if (!automationService) return;
      setIsLoading(true);
      const response = await automationService.createJourney(name);
      setIsLoading(false);
      return response;
    },
    [automationService]
  );

  return { isLoading, createJourney };
};
